<template>
    <footer class="text-white site-footer">
        <!-- Gradient background wrapper -->
        <div class="bg-gradient-to-r from-blue-900 via-purple-800 to-pink-700 p-4 sm:p-6 lg:p-8 text-white relative overflow-hidden">
            <div class="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32 hidden sm:block"></div>
            <div class="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24 hidden sm:block"></div>
            
            <div class="relative z-10">
                <!-- Main Footer Content -->
                <div class="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8 pt-8 sm:pt-12">
                    <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-12 mb-12 sm:mb-16">
                        
                        <!-- Brand Column -->
                        <div class="col-span-2 lg:col-span-2">
                   <div class="flex flex-col   mb-6">
            
    <!-- Logo Box (SVG) -->
<div class="flex items-center justify-start">
    <div class="h-14 sm:h-16 md:h-20 flex-shrink-0">
        <img
            :src="logo"
            alt="Online Self Test Logo"
            class="h-full w-auto object-contain"
             loading="lazy"
        />
    </div>
</div>

    <!-- Tagline Paragraph (stacked below logo) -->
    <p class="text-white text-xs sm:text-sm md:text-base leading-relaxed mt-0 max-w-[20rem] sm:max-w-[16rem] md:max-w-[20rem] lg:max-w-[24rem]">
        India’s leading AI-driven learning platform, helping students reach their academic goals with smart, personalized learning journeys.
    </p>
</div>

                            
                           
                            <!-- Social Links -->
                            <div class="flex flex-wrap gap-3 sm:gap-4 mb-6">
                                <a aria-label="Facebook" href="https://www.facebook.com/onlineselftest"  target="_blank" class="w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-sm rounded-xl p-2 sm:p-3 border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all group flex items-center justify-center text-white">
                                    <i class="fab fa-facebook-f text-sm sm:text-base"></i>
                                </a>
                                <a aria-label="Twitter" href="https://x.com/onlineselftest"  target="_blank" class="w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-sm rounded-xl p-2 sm:p-3 border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all group flex items-center justify-center text-white">
                                    <i class="fab fa-twitter text-sm sm:text-base"></i>
                                </a>
                                <a aria-label="Instagram" href="https://www.instagram.com/onlineselftest/"  target="_blank" class="w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-sm rounded-xl p-2 sm:p-3 border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all group flex items-center justify-center text-white">
                                    <i class="fab fa-instagram text-sm sm:text-base"></i>
                                </a>
                                <a aria-label="LinkedIn" href="https://www.linkedin.com/company/onlineselftest?trk=public_post_feed-actor-name"  target="_blank" class="w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-sm rounded-xl p-2 sm:p-3 border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all group flex items-center justify-center text-white">
                                    <i class="fab fa-linkedin-in text-sm sm:text-base"></i>
                                </a>
                                <a aria-label="YouTube" href="https://www.youtube.com/@onlineselftest"  target="_blank" class="w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-sm rounded-xl p-2 sm:p-3 border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all group flex items-center justify-center text-white">
                                    <i class="fab fa-youtube text-sm sm:text-base"></i>
                                </a>
                            </div>

                            <!-- Download App Buttons -->
                            <div class="flex flex-col xs:flex-row gap-3 hidden">
                                <a aria-label="Download on App Store" href="#" class="inline-flex items-center bg-white/5 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all group flex-1 justify-center sm:justify-start">
                                    <i class="fab fa-apple text-xl sm:text-2xl mr-3 text-white"></i>
                                    <div>
                                            <div class="text-xs text-white">Download on</div>
                                        <div class="text-sm font-bold text-white">App Store</div>
                                    </div>
                                </a>
                                <a aria-label="Download on Google Play" href="#" class="inline-flex items-center bg-white/5 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all group flex-1 justify-center sm:justify-start">
                                    <i class="fab fa-google-play text-xl sm:text-2xl mr-3 text-white"></i>
                                    <div>
                                        <div class="text-xs text-white">Get it on</div>
                                        <div class="text-sm font-bold text-white">Google Play</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        
                        <!-- Education Boards -->
                        <div class="hidden md:block">
                            <h3 class="font-black text-base sm:text-lg mb-4 sm:mb-6 text-white">Quizzes</h3>
                            <ul class="space-y-2 sm:space-y-3">
                                <li><a href="/quiz/8th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 8th</a></li>
                                <li><a href="/quiz/9th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 9th</a></li>
                                <li><a href="/quiz/10th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 10th</a></li>
                                <li><a href="/quiz/11th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 11th</a></li>
                                <li><a href="/quiz/12th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 12th</a></li>
                            </ul>
                        </div>
                        
                        <!-- Competitive Exams -->
                        <div class="hidden md:block">
                            <h3 class="font-black text-base sm:text-lg mb-4 sm:mb-6 text-white">Resources</h3>
                            <ul class="space-y-2 sm:space-y-3">
                                <li><a href="/learn/8th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 8th</a></li>
                                <li><a href="/learn/9th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 9th</a></li>
                                <li><a href="/learn/10th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 10th</a></li>
                                <li><a href="/learn/11th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 11th</a></li>
                                <li><a href="/learn/12th" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">class 12th</a></li>
                            </ul>
                        </div>
                        
                        <!-- Company -->
                        <div class="hidden md:block col-span-2 md:col-span-1">
                            <h3 class="font-black text-base sm:text-lg mb-4 sm:mb-6 text-white">Company</h3>
                            <ul class="space-y-2 sm:space-y-3">
                                <li><a href="/about-us" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">About Us</a></li>
                                
                                <li><a href="/contact" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">Contact</a></li>
                                 <li><a href="/faq" class="text-white text-sm sm:text-base hover:opacity-90 transition-colors hover:translate-x-1 inline-block">FAQ</a></li>
                            </ul>
                        </div>
                    </div>

                    <!-- Bottom Bar -->
                    <div class="border-t border-white/10 sm:py-6 pt-6 pb-8">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
                            <p class="text-white text-xs sm:text-sm">
                                © 2026 <strong class="font-semibold">onlineselftest.com</strong>. All rights reserved.
                            </p>
                            <div class="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm">
                                <router-link to="/privacy-policy" class="text-white hover:opacity-90 transition-colors">Privacy Policy</router-link>
                                <span class="text-white text-xs hidden sm:inline">•</span>
                                <router-link to="/terms" class="text-white hover:opacity-90 transition-colors">Terms of Service</router-link>
                                <span class="text-white text-xs hidden sm:inline">•</span>
                                <router-link to="/cookies-policy" class="text-white hover:opacity-90 transition-colors">Cookie Policy</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import logo from '@/assets/onlineselftest_logo.svg';

export default {
  name: "SiteFooter",
  data() {
    return { logo };
  }
};
</script>

<style scoped>
/* Custom breakpoint for extra small screens */
@media (min-width: 475px) {
    .xs\:flex-row {
        flex-direction: row;
    }
}

/* Smooth transitions for all interactive elements */
a, button {
    transition: all 0.3s ease;
}

/* Ensure proper text rendering */
.font-display {
    font-family: system-ui, -apple-system, sans-serif;
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
}

::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}
</style>